import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import Swal from 'sweetalert2'
import vSelect from "vue-select"
import datePicker from 'vuejs-datepicker'
import "vue-select/dist/vue-select.css"
import VueTheMask from 'vue-the-mask'
import VueHtmlToPaper from 'vue-html-to-paper'
import { Cropper } from 'vue-advanced-cropper';
import QrcodeVue from 'qrcode.vue'
import 'vue-advanced-cropper/dist/style.css';
import jQuery from "jquery"
global.jQuery = jQuery
global.$ = jQuery

Vue.config.productionTip = false

Vue.prototype.$axios = Axios
Vue.prototype.$toast = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})

Vue.directive('focus', {
   inserted: function (el) {
      el.focus()
   }
})

Vue.use(VueTheMask)
Vue.use(VueHtmlToPaper)
Vue.component(Cropper)
Vue.component('qrcode-vue', QrcodeVue)
Vue.component("v-select", vSelect)
Vue.component("datePicker", datePicker)

require("@/assets/cliente/css/preloader.css")
require("@/assets/cliente/css/bootstrap.min.css")
require("@/assets/cliente/css/slick.css")
require("@/assets/cliente/css/backToTop.css")
require("@/assets/cliente/css/meanmenu.css")
require("@/assets/cliente/css/nice-select.css")
require("@/assets/cliente/css/owl.carousel.min.css")
require("@/assets/cliente/css/animate.min.css")
require("@/assets/cliente/css/fontAwesome5Pro.css")
require("@/assets/cliente/css/default.css")
require("@/assets/cliente/css/style.css")
require("@/assets/cliente/js/vendor/jquery-3.6.0.min.js")
require("@/assets/cliente/js/vendor/waypoints.min.js")
require("@/assets/cliente/js/bootstrap.bundle.min.js")
require("@/assets/cliente/js/meanmenu.js")
require("@/assets/cliente/js/slick.min.js")
require("@/assets/cliente/js/backToTop.js")
require("@/assets/cliente/js/nice-select.min.js")
require("@/assets/cliente/js/owl.carousel.min.js")

require('@/assets/admin/fonts/overpass/stylesheet.css')
require('@/assets/admin/css/light-themes/app.css')
require('@/assets/admin/css/light-themes/success-theme.css')
require('@/assets/admin/css/light-themes/primary-theme.css')
require('@/assets/admin/css/light-themes/warning-theme.css')
require('@/assets/admin/css/icons.css')
require('@/assets/admin/css/dark-themes/dark-theme.css')
require('@/assets/admin/css/dark-themes/primary-theme.css')
require('@/assets/admin/css/dark-themes/success-theme.css')
require('@/assets/admin/css/dark-themes/danger-theme.css')

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
